import type { CSSProperties, ReactNode } from 'react';

export interface SigLabelProps {
  children: ReactNode;
  style?: CSSProperties;
}

export function SigLabel({ children, style }: SigLabelProps) {
  return (
    <div className="sig-label" style={style}>
      {children}
    </div>
  );
}
